import React from 'react';
import { PasswordlessAuthProvider } from '../provider/PasswordlessAuthContext';

const PasswordlessAuthWrapper = ({ children }) => {
  return (
    <PasswordlessAuthProvider>
      {children}
    </PasswordlessAuthProvider>
  );
};

export default PasswordlessAuthWrapper; 